var SourceGroupChannels = (function (backOffice, $) {
    backOffice.SourceGroupChannels = (function () {

        var baseApiPath = window.location.origin + '/dotnet/admin/api/';

        var exportToWebOptions = {
            selectValue: {
                text: "Select a Value",
                value: 0
            },
            setAndPublish: {
                text: "Set Channels & Publish",
                value: 1
            },
            resetAndUnpublish: {
                text: "Reset Channels & Unpublish",
                value: 2
            },
            publishOnly: {
                text: "Publish Only",
                value: 3
            },
            unpublishOnly: {
                text: "Unpublish Only",
                value: 4
            }
        };

        var exportToWebOptionListId = "#export-to-web-options-select";
        var saleChannelListId = "#sale-channels-select";
        var sourceGroupListId = "#source-groups-select";

        var channelGroupSelection = {};
        
        var saleChannels = [];
        var configuration = {};

        function init(config) {
            configuration = config;

            getSaleChannels(function (channels) {
                setup(channels);
            });
            
        }

        function setup(channels) {
            if (channels && channels.length) {
                saleChannels = channels;
                initExportToWebOptionList();
                initSaleChannelList();
                configureHandlers();
            }
        }

        function initExportToWebOptionList() {
            var optionsHtml = "";

            for (var optionName in exportToWebOptions) {
                var option = exportToWebOptions[optionName];

                optionsHtml += createListOptionHtml(
                    option.text,
                    option.value,
                    (option.value === exportToWebOptions.selectValue.value));
            }

            $(exportToWebOptionListId).append(optionsHtml);
        }

        function initSaleChannelList() {
            var optionsHtml = "";
            for (var i = 0; i < saleChannels.length; i++) {
                optionsHtml += createListOptionHtml(saleChannels[i].name, saleChannels[i].id);
            }
            $(saleChannelListId).append(optionsHtml);
        }

        function initSourceGroupList(selectedChannelId) {
            clearSourceGroupList();

            var channelGroups = saleChannels.find(function (c) {
                return c.id == selectedChannelId;
            }).sourceGroups;

            if (channelGroups && channelGroups.length) {
                var optionsHtml = "";

                for (var i = 0; i < channelGroups.length; i++) {
                    optionsHtml += createListOptionHtml(
                        channelGroups[i].name,
                        channelGroups[i].id,
                        channelGroups[i].id == getSelectedChannelGroup(selectedChannelId)
                    );
                }

                $(sourceGroupListId).append(optionsHtml);
            }
        }

        function clearSourceGroupList() {
            $(sourceGroupListId + " option").remove();
        }

        function configureHandlers() {
            var changeEventName = "change";

            $(exportToWebOptionListId).off(changeEventName).on(changeEventName, function () {
                var selectedValue = $(this).val();
                handleExportToWebOptionChange(selectedValue);
            }).trigger(changeEventName);

            $(saleChannelListId).off(changeEventName).on(changeEventName, function () {
                var selectedChannelId = $(this).val();
                initSourceGroupList(selectedChannelId);
            });

            $(sourceGroupListId).off(changeEventName).on(changeEventName, function () {
                var selectedGroupId = $(this).val();
                var selectedChannelId = $(saleChannelListId).val();
                saveSelectedChannelGroup(selectedChannelId, selectedGroupId);
            });

        }

        function disableSourceGroupLists() {
            $(sourceGroupListId).prop("disabled", true);
            $(saleChannelListId).prop("disabled", true);
        }

        function enableSourceGroupLists() {

            $(sourceGroupListId).prop("disabled", false);
            $(saleChannelListId).prop("disabled", false);
        }

        function clearSelection() {
            $(saleChannelListId)
                .val("");

            clearSourceGroupList();

            channelGroupSelection = [];
        }

        function reset() {
            $(exportToWebOptionListId)
                .val(exportToWebOptions.selectValue.value);

            clearSelection();

        }

        function handleExportToWebOptionChange(selectedValue) {
            if (selectedValue == exportToWebOptions.setAndPublish.value) {
                enableSourceGroupLists();
            } else {
                clearSelection();
                disableSourceGroupLists();
            }
        }

        function getChannelGroupSelectionAsString() {
            var channelGroupsSelectionStr = "";
            $(saleChannelListId + " option").each(function () {
                var channelId = $(this).val();
                var selectedGroupId = getSelectedChannelGroup(channelId);
                if (selectedGroupId) {
                    channelGroupsSelectionStr += (channelId + "," + selectedGroupId + "|");
                }
            });
            return channelGroupsSelectionStr.slice(0, -1);
        }

        function createListOptionHtml(text, value, selected) {
            var selectedAttr = selected ? 'selected' : '';
            return `<option value="${value}" ${selectedAttr}>${text}</option>`
        }

        function getSelectedChannelGroup(channelId) {
            return channelGroupSelection[channelId];
        }

        function saveSelectedChannelGroup(channelId, groupId) {
            channelGroupSelection[channelId] = groupId;
        }


        function getSaleChannels(success) {
            $.ajax({
                method: 'GET',
                async: true,
                url: baseApiPath + 'channels',
                contentType: 'application/json',
                success: success
            });
        }

        function apply(filters, successFunc, errorFunc, toggleFunc) {
            var exportToWebSelectedOption = $(exportToWebOptionListId).val();

            if (validateSelectedExportToWebOption(exportToWebSelectedOption)) {
                filters.PublishOption = parseInt(exportToWebSelectedOption)
                filters.ProductChannelGroups = getChannelGroupSelectionAsString();

                toggleFunc = toggleFunc ? toggleFunc : function (toggle) { };

                toggleFunc(true);

                $.ajax({
                    method: 'POST',
                    async: true,
                    data: JSON.stringify(filters),
                    url: baseApiPath + 'exporttoweb',
                    contentType: 'application/json',
                    success: function (result) {
                        writeToResultPlaceholder(result);
                        if (successFunc) {
                            successFunc(result);
                        }

                    },
                    error: function () {
                        if (errorFunc) {
                            errorFunc();
                        }
                    },
                    complete: function () {
                        toggleFunc(false);
                    }
                });
            }
        }

        function validateSelectedExportToWebOption(option) {
            if (option == exportToWebOptions.selectValue.value) {
                writeToResultPlaceholder("Please select Export To Web publishing option");
                return false;
            }
            return true;
        }

        function writeToResultPlaceholder(text) {
            if (text) {
                var messagePlaceholder = $(configuration.resultMessagePlaceholderId);

                if (messagePlaceholder) {
                    messagePlaceholder.val(text);
                }
            }
        }


        return $.extend(backOffice.SourceGroupChannels, {
            Init: init,
            Reset: reset,
            Apply: apply,
            Validate: validateSelectedExportToWebOption
        });

    })();

    return backOffice.SourceGroupChannels;

})(BackOffice || {}, jQuery);